import { apiRequest } from "../api";

export const getSupportTickets = (query: string | URLSearchParams) =>
  apiRequest(`/support/tickets?${query.toString()}`, "GET");
export const getSupportStats = () => apiRequest("/support/stats", "GET");
export const getSupportTicket = (id: string | undefined) =>
  apiRequest(`/support/tickets/${id}`, "GET");
export const updateSupportTicket = (id: string | undefined, payload: unknown) =>
  apiRequest(`/support/tickets/${id}`, "PUT", payload);
